import type { Product } from '@ztechapps/common.contract'
import isEmpty from 'lodash/isEmpty'

export function hasSubComponents(product: Product) {
  return !isEmpty(product?.billOfMaterials)
}
